<template>
  <div id="page3">
  <img id="up" src="img/up.png" class="image" style="width: 5%; height: 5%;margin-bottom: 0%">
    <h1> My Blogs</h1>
  <el-row>
    <el-col :span="6" :offset="4">
      <div class="post">
        <Fabric_1> </Fabric_1>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="post">
        <Fabric_2> </Fabric_2>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="post">
        <Go_book> </Go_book>
      </div>
    </el-col>
  </el-row>
    <el-row>
      <el-col :span="6" :offset="4">
        <div class="post">
          <Go_sync> </Go_sync>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="post">

        </div>
      </el-col>
  </el-row>
  </div>
</template>

<script>
import Fabric_1 from "@/components/page3/postCard/fabric_1";
import Fabric_2 from "@/components/page3/postCard/fabric_2";
import Go_book from "@/components/page3/postCard/go_book";
import Go_sync from "@/components/page3/postCard/go_sync";
export default {
  name: "pageThree",
  components: { Go_sync, Go_book, Fabric_2, Fabric_1}
}
</script>

<style scoped>
#up{
  animation: fadeInDown; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}
a{
  text-decoration: none;
  color: aliceblue;
}

#page3{
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}

.post{
  border-radius:5px;
}
</style>